import { render, staticRenderFns } from "./AddressListRight.vue?vue&type=template&id=4184f749&scoped=true"
import script from "./AddressListRight.vue?vue&type=script&lang=js"
export * from "./AddressListRight.vue?vue&type=script&lang=js"
import style0 from "./AddressListRight.vue?vue&type=style&index=0&id=4184f749&prod&lang=css"
import style1 from "./AddressListRight.vue?vue&type=style&index=1&id=4184f749&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4184f749",
  null
  
)

export default component.exports